if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {

        console.log("evt",evt);
        var addComplementaryProduct = false;
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        // this.querySelector('.loading__spinner').classList.remove('hidden');

        var config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

config.body = formData;

        

// ---------------- custom code -----------------
// const signatureProduct = document.querySelector("#signatureProduct");
// if (signatureProduct) {
//   if (signatureProduct.getAttribute("data-addProduct") == "true") {
//     var addComplementaryProduct = true;
//     console.log("signatureProduct", signatureProduct);
//     var signatureProduct_data = signatureProduct.parentElement.querySelector("[name='signature_id']")
//     var signature_title = signatureProduct_data.getAttribute("data-title");
//     var signature_variantId = Number(signatureProduct_data.getAttribute("data-varianbt_Id"));
//     var main_product_title = signatureProduct_data.getAttribute("data-related_product_title");
//     var main_product_id = signatureProduct_data.getAttribute("data-main_product_id");
//   }
// }

// if (addComplementaryProduct) {
//   let mainID, mainQuantity;
//   for (let pair of formData.entries()) {
//     if (pair[0] == 'id') mainID = pair[1];
//     if (pair[0] == 'quantity') mainQuantity = pair[1];
//   }

//   console.log("mainID", mainID);
//   console.log("mainQuantity", mainQuantity);

//   let formDataNew = {
//     items: [
//       {
//         id: mainID,
//         quantity: mainQuantity
//       },
//       {
//         id: signature_variantId,
//         quantity: mainQuantity,
//         properties: {
//           "_Main_prduct_title": main_product_title,
//           "_Main_variant_id": main_product_id
//         }
//       }
//     ]
//   };

//   // ✅ Add paper product if selected and valid
//   const paperElement = document.querySelector('product-quality_paper');
//   if (paperElement) {
//     const selectedCheckbox = paperElement.querySelector('.paper_product_selected:checked');
//     if (selectedCheckbox) {
//       const paper_variantId = selectedCheckbox.value;
//       const paper_quantity = Number(selectedCheckbox.getAttribute('data-quantity') || 1);
//       const paper_inventory = Number(selectedCheckbox.getAttribute('data-inventory_quantity') || 0);

//       if (paper_quantity <= paper_inventory) {
//         formDataNew.items.push({
//           id: paper_variantId,
//           quantity: paper_quantity,
//           if (parentId) {
//             fd.append('parent_line_key', parentId);
//           }


//         });
//       } else {
//         console.error(`❌ Not enough inventory for paper product. Requested: ${paper_quantity}, Available: ${paper_inventory}`);
//         alert("Selected paper quality product does not have enough inventory.");
//       }
//     }
//   }

//   console.log("formDataNew", formDataNew);

//   var formData1 = new FormData();
//   formDataNew.items.forEach(function (item, index) {
//     formData1.append(`items[${index}][id]`, item.id);
//     formData1.append(`items[${index}][quantity]`, item.quantity);
//     if (item.properties) {
//       Object.keys(item.properties).forEach((key) => {
//         formData1.append(`items[${index}][properties][${key}]`, item.properties[key]);
//       });
//     }
//   });

//   for (let pair of formData1.entries()) {
//     console.log(pair[0], pair[1]);
//   }

//   if (this.cart) {
//     formData1.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
//   }

//   formData1.append('sections_url', window.location.pathname);
//   newConfig.body = formData1;
//   // ---------------- custom code -----------------
// }





// ---------------- custom code -----------------

let additionalProducts = [];

// 📌 Signature Product Handling (checkbox)
const signatureProduct = document.querySelector('#signatureProduct');
if (signatureProduct && signatureProduct.checked) {
  const signatureProductData = signatureProduct.closest('.signature_product')?.querySelector("[name='signature_id']");
  const signatureVariantId = Number(signatureProductData.getAttribute("data-varianbt_Id"));
  const mainProductTitle = signatureProductData.getAttribute("data-related_product_title");
  const mainProductId = signatureProductData.getAttribute("data-main_product_id");

  additionalProducts.push({
    id: signatureVariantId,
    quantity: 1,
  });
}

// 📌 Paper Product Handling
const paperElement = document.querySelector('product-quality_paper');
if (paperElement) {
  const selectedCheckbox = paperElement.querySelector('.paper_product_selected:checked');
  if (selectedCheckbox) {
    const paperVariantId = Number(selectedCheckbox.value);
    const paperQuantity = Number(selectedCheckbox.getAttribute('data-quantity') || 1);
    const paperInventory = Number(selectedCheckbox.getAttribute('data-inventory_quantity') || 0);

    if (paperQuantity <= paperInventory) {
      additionalProducts.push({
        id: paperVariantId,
        quantity: paperQuantity
      });
    } else {
      console.error(`❌ Not enough inventory for paper product. Requested: ${paperQuantity}, Available: ${paperInventory}`);
      alert("Selected paper quality product does not have enough inventory.");
    }
  }
}

console.log("let additionalProducts =", JSON.stringify(additionalProducts.length ? additionalProducts : null, null, 2));

// ---------------- custom code -----------------
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
// ------------------------------------------------------------------------------------------
  console.log("new product added");
  console.log(additionalProducts.length);
  
if (additionalProducts && additionalProducts.length && response?.key) {
  // Add parent_line_key to each item directly (though Shopify may ignore it)
  var customProductData = additionalProducts.map(product => ({
    ...product,
    parent_line_key: response.key  // 👈 Not inside properties
  }));
  console.log("updatedProducts =", JSON.stringify(customProductData, null, 2));
fetch('/cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  body: JSON.stringify({ items: customProductData })
})
  .then((res) => res.json())
  .then((customResponse) => {
    console.log('Custom product added:', customResponse);
    if (this.cart && typeof this.cart.renderContents === 'function') {
      this.cart.renderContents(customResponse);
    }
    if (customResponse.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: customResponse.errors || customResponse.description,
                message: customResponse.message,
              });
              this.handleErrorMessage(customResponse.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
  })
  .catch((e) => {
    console.error('Error adding custom product:', e);
  });
}
// ------------------------------------------------------------------------------------------

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              if(additionalProducts.length == 0){
                  window.location = window.routes.cart_url;
              }
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');


            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
